import { fillXmlFormDemo } from '@/pages/api/scribeAPIV2';
import { type FillXmlFormDemoRequest, type FillXmlFormDemoResponse } from '@/types';
import { DEMO_FILL_XML_FORM_MUTATION_KEY } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export function useMutateFillXmlFormDemo() {
  return useMutation<FillXmlFormDemoResponse, Error, FillXmlFormDemoRequest>({
    mutationKey: DEMO_FILL_XML_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillXmlFormDemo(request);
      return data;
    },
  });
}
